import { createFileRoute } from '@tanstack/react-router'
import { AppointmentsPage, parseSearch, type AppointmentsSearch } from '@/features/appointments'

/** C-01 Appointments (the clinic home) with its filters, page and drawer (`appt`) in the URL (Frontend §6.1). */
export const Route = createFileRoute('/_authed/clinics/$clinicId/appointments')({
  validateSearch: (raw: Record<string, unknown>): AppointmentsSearch => parseSearch(raw),
  component: function AppointmentsRoute() {
    const { clinicId } = Route.useParams()
    const { timeZone } = Route.useRouteContext()
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    return (
      <AppointmentsPage
        clinicId={clinicId}
        timeZone={timeZone}
        search={search}
        onSearch={(next, opts) => {
          void navigate({ search: next, replace: opts?.replace ?? false })
        }}
      />
    )
  },
})
